import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const CheckCircleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path transform="translate(2 2)" id="a" d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zM7.29 14.29L3.7 10.7a.996.996 0 1 1 1.41-1.41L8 12.17l5.967-6.228a.996.996 0 1 1 1.41 1.41L8.7 14.29a.996.996 0 0 1-1.41 0z" />
  </SvgIcon>
);
